import { types } from 'mobx-state-tree';

export const Location = types.model('location', {
  city: types.maybe(types.string),
  state: types.maybe(types.string),
  country: types.maybe(types.string),
  zip_code: types.maybe(types.string),
});
